import t_03_1470 from './KZ.T.03.1470.svg'

export default [
  t_03_1470,
]
